// ShopServ.js
import { get, post, put, patch, destroy } from "./base";

const ShopServ = {
  index: (params) => get("/shops", { params }),
  adminIndex: (params) => get("/shops/admin/all-shops", { params }),
  getSellerShops: (params) => get("/shops/seller/my-shops", { params }),
  single: (id) => get(`/shops/${id}`),
  create: (payload) => post("/shops", payload),
  update: (id, payload) => {
    return put(`/shops/${id}`, payload)
      .catch(error => {
        throw error;
      });
  },
  remove: (id) => destroy(`/shops/${id}`),
  updateStatus: (id, status, rejectionReason) =>
    patch(`/shops/${id}/status`, { status, rejectionReason }),
  upload: (formData) => post("/upload/image", formData), // Supports file upload
};

export default ShopServ;
